import { render } from "./MpidPage.vue?vue&type=template&id=ef3d8c62&scoped=true"
import script from "./MpidPage.vue?vue&type=script&lang=js"
export * from "./MpidPage.vue?vue&type=script&lang=js"

import "./MpidPage.vue?vue&type=style&index=0&id=ef3d8c62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef3d8c62"]])

export default __exports__